// Motor do formulário nativo de procuração: "quem vê", blocos de endereço,
// validação e as regras de conta (idade, perfil, quem assina, idioma).
//
// CÓPIA de cj-automations: src/domain/procuracao-nativa/derivados.ts e
// motor.ts. O backend valida o envio com as mesmas regras — ao mudar uma
// regra, mude nos dois lugares.

const PAISES_INGLES = ['estados unidos', 'eua', 'reino unido', 'inglaterra', 'escócia', 'país de gales', 'irlanda', 'canadá', 'austrália', 'nova zelândia', 'áfrica do sul'];
export const FILHO_OU_NETO = 'Filho(a) ou neto(a)';
export const PAISES_ENDERECO = ['Brasil', 'Portugal', 'Estados Unidos', 'Reino Unido', 'Canadá', 'Outro país'];

const texto = (v) => (v === undefined || v === null ? '' : String(v).trim());

export function anosEntre(de, ate) {
  const a = /^(\d{4})-(\d{2})-(\d{2})/.exec(texto(de));
  const b = /^(\d{4})-(\d{2})-(\d{2})/.exec(texto(ate));
  if (!a || !b) return null;
  let n = Number(b[1]) - Number(a[1]);
  if (Number(b[2]) < Number(a[2]) || (Number(b[2]) === Number(a[2]) && Number(b[3]) < Number(a[3]))) n--;
  return n;
}

export function hojeIso(agora = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${agora.getFullYear()}-${p(agora.getMonth() + 1)}-${p(agora.getDate())}`;
}

export function paisDoEndereco(r, prefixo) {
  const pais = texto(r[`${prefixo}Pais`]);
  return pais === 'Outro país' ? texto(r[`${prefixo}PaisOutro`]) : pais;
}

export function idiomaPorPais(pais) {
  return PAISES_INGLES.includes(pais.trim().toLowerCase()) ? 'ingles' : 'portugues';
}

const primeiroNome = (nome, reserva) => (texto(nome) || reserva).split(/\s+/)[0] || '';

export function derivadosAtribuicao(r, ctx, hoje = hojeIso()) {
  const idade = anosEntre(r.nascimento, hoje);
  const tipo = (ctx.tipoProcesso || '').toLowerCase();
  const perfil = idade === null
    ? (tipo.includes('menor') ? (tipo.includes('até 13') ? 'menor13' : 'menor14') : 'adulto')
    : idade < 14 ? 'menor13' : idade < 18 ? 'menor14' : 'adulto';
  const menor = perfil !== 'adulto';
  const sem = ['Já faleceu', 'Não consta na certidão'];
  const maeFora = sem.includes(texto(r.maeSituacao));
  const paiFora = sem.includes(texto(r.paiSituacao));
  const maeViva = r.maeSituacao === 'Está viva';
  const paiVivo = r.paiSituacao === 'Está vivo';
  const semPais = menor && maeFora && paiFora;
  const soUm = !menor ? '' : maeFora && paiVivo ? 'pelo pai' : paiFora && maeViva ? 'pela mãe' : '';
  const idioma = idiomaPorPais(paisDoEndereco(r, 'end'));
  let modelo = '';
  if (perfil === 'adulto') modelo = `atribuicao_${idioma}`;
  else if (idioma === 'ingles') modelo = 'menor_ingles';
  else if (maeViva && paiVivo) modelo = 'menor_portugues_pais_vivos';
  else if (r.paiSituacao === 'Já faleceu' && maeViva) modelo = 'menor_portugues_pai_falecido';
  else if (r.maeSituacao === 'Já faleceu' && paiVivo) modelo = 'menor_portugues_mae_falecida';
  else if (r.paiSituacao === 'Não consta na certidão' && maeViva) modelo = 'menor_portugues_so_mae';
  else if (r.maeSituacao === 'Não consta na certidão' && paiVivo) modelo = 'menor_portugues_so_pai';
  else if (semPais) modelo = 'responsavel_legal';
  return {
    idade, perfil, menor, adulto: !menor, menor13: perfil === 'menor13', menor14: perfil === 'menor14', neto: !!ctx.neto,
    primeiro: primeiroNome(r.nome, ctx.requerente || ''), idioma, maeViva, paiVivo,
    doisVivos: menor && maeViva && paiVivo, soUmVivo: menor && maeViva !== paiVivo, semPais, soUm, modelo,
  };
}

export function derivadosTranscricao(r, ctx) {
  const depois2019 = texto(r.casData) >= '2019-01-01';
  const temData = !!texto(r.casData);
  const vivoNoivo = r.noivoSituacao !== 'Já faleceu';
  const vivoNoiva = r.noivaSituacao !== 'Já faleceu';
  const cidadania = texto(r.cidadania);
  const opcoes = [];
  if (depois2019) {
    if (vivoNoivo && vivoNoiva) opcoes.push('Os dois noivos');
    else if (vivoNoivo) opcoes.push('O noivo');
    else if (vivoNoiva) opcoes.push('A noiva');
  } else {
    if ((cidadania === 'O noivo' || cidadania === 'Os dois') && vivoNoivo) opcoes.push('O noivo');
    if ((cidadania === 'A noiva' || cidadania === 'Os dois') && vivoNoiva) opcoes.push('A noiva');
  }
  opcoes.push(FILHO_OU_NETO);
  const quem = opcoes.length === 1 ? FILHO_OU_NETO : opcoes.includes(texto(r.quemAssina)) ? texto(r.quemAssina) : '';
  const assinaNoivo = quem === 'O noivo' || quem === 'Os dois noivos';
  const assinaNoiva = quem === 'A noiva' || quem === 'Os dois noivos';
  const assinaFilho = quem === FILHO_OU_NETO;
  const noivaNoMesmo = assinaNoivo && assinaNoiva && r.noivaMesmoEndNoivo !== false;
  const assinantes = [assinaNoivo && 'noivo', assinaNoiva && 'noiva', assinaFilho && 'ass'].filter(Boolean);
  const idiomaDe = (pre) => idiomaPorPais(paisDoEndereco(r, pre === 'noiva' && noivaNoMesmo ? 'noivo' : pre));
  return {
    temData, depois2019, antes2019: temData && !depois2019, vivoNoivo, vivoNoiva,
    opcoesQuemAssina: opcoes, soFilhoPodeAssinar: opcoes.length === 1, quemAssina: quem,
    assinaNoivo, assinaNoiva, assinaFilho, assinaOsDois: assinaNoivo && assinaNoiva, noivaNoMesmo,
    assinantes, nProcuracoes: assinantes.length,
    modelos: assinantes.map((a) => `${a}: transcricao_${depois2019 ? 'depois' : 'antes'}_2019_${idiomaDe(a)}`),
    nomeNoivo: primeiroNome(r.noivoSolteiro, 'noivo'), nomeNoiva: primeiroNome(r.noivaSolteiro, 'noiva'),
    noivoPortugues: r.noivoNac === 'Português', noivaPortuguesa: r.noivaNac === 'Portuguesa', pt: ctx.pt,
  };
}

const LIVRO_DA_MATRICULA = { 1: 'nascimento', 2: 'casamento', 3: 'casamento', 4: 'óbito', 5: 'óbito' };

/** Matrícula da certidão (32 dígitos): CNS(6) acervo(2) serviço(2) ano(4) tipo do livro(1) livro(5) folha(3) termo(7) dígito(2). */
export function lerMatricula(v) {
  const d = texto(v).replace(/\D/g, '');
  if (d.length !== 32) return null;
  return { ano: d.slice(10, 14), tipoLivro: d.charAt(14), livro: d.slice(15, 20), folha: d.slice(20, 23), termo: d.slice(23, 30) };
}

/** Pedido de emissão de certidão (antigo Typeform Ly2sGj). */
export function derivadosEmissao(r, ctx) {
  const doc = ctx.documento || {};
  const casamento = doc.tipo === 'casamento';
  const m = lerMatricula(r.matricula);
  const matriculaTipo = m ? LIVRO_DA_MATRICULA[m.tipoLivro] || '' : '';
  const anoRegistro = texto(r.dataRegistro).slice(0, 4);
  return {
    casamento,
    nascimento: !casamento,
    semCopia: r.semCopia === true,
    evento: casamento ? 'casamento' : 'nascimento',
    rotEvento: casamento ? 'Data do casamento' : 'Data de nascimento',
    docTitulo: casamento ? 'Certidão de casamento' : 'Certidão de nascimento',
    docMin: casamento ? 'certidão de casamento' : 'certidão de nascimento',
    descricao: doc.descricao || '',
    custasPeloCliente: !!doc.custasPeloCliente,
    temMatricula: !!m,
    matriculaTipo,
    matriculaOutroTipo: !!matriculaTipo && matriculaTipo !== (casamento ? 'casamento' : 'nascimento'),
    matriculaAno: m ? m.ano : '',
    matriculaOutroAno: !!m && !!anoRegistro && anoRegistro !== m.ano,
  };
}

const DERIVADOS = { atribuicao: (r, ctx) => derivadosAtribuicao(r, ctx), transcricao: derivadosTranscricao, emissao_certidao: derivadosEmissao };

export const derivar = (form, r, ctx) => (DERIVADOS[form.codigo] ? DERIVADOS[form.codigo](r, ctx) : {});

const vazio = (v) => v === undefined || v === null || (typeof v === 'string' && v.trim() === '') || (Array.isArray(v) && v.length === 0);

export function avaliar(cond, r, d) {
  if (!cond) return true;
  if (cond.todas) return cond.todas.every((c) => avaliar(c, r, d));
  if (cond.alguma) return cond.alguma.some((c) => avaliar(c, r, d));
  if (cond.nao) return !avaliar(cond.nao, r, d);
  const valor = 'campo' in cond ? r[cond.campo] : d[cond.derivado];
  if (cond.preenchido !== undefined && cond.preenchido === vazio(valor)) return false;
  if ('igual' in cond && valor !== cond.igual) return false;
  if ('diferente' in cond && valor === cond.diferente) return false;
  if (cond.em && !cond.em.includes(valor)) return false;
  return true;
}

export const interpolar = (t, d) => String(t || '').replace(/\{(\w+)\}/g, (m, nome) => (d[nome] === undefined || d[nome] === null ? m : String(d[nome])));

export function expandirEndereco(b) {
  const p = b.prefixo;
  const base = b.visivelSe || { todas: [] };
  const noBrasil = { todas: [base, { campo: `${p}Pais`, igual: 'Brasil' }] };
  const fora = { todas: [base, { campo: `${p}Pais`, preenchido: true }, { campo: `${p}Pais`, diferente: 'Brasil' }] };
  const itens = [];
  if (b.titulo) itens.push({ tipo: 'secao', titulo: b.titulo, sub: b.sub, visivelSe: b.visivelSe });
  itens.push(
    { tipo: 'opcoes', chave: `${p}Pais`, rotulo: 'País', opcoes: PAISES_ENDERECO, padrao: 'Brasil', visivelSe: b.visivelSe, enderecoDe: p },
    { tipo: 'texto', chave: `${p}PaisOutro`, rotulo: 'Qual país?', meia: true, visivelSe: { todas: [base, { campo: `${p}Pais`, igual: 'Outro país' }] }, enderecoDe: p },
    { tipo: 'cep', chave: `${p}Cep`, rotulo: 'CEP', meia: true, placeholder: '00000-000', validacao: 'cep', visivelSe: noBrasil, enderecoDe: p },
    { tipo: 'texto', chave: `${p}Logradouro`, rotulo: 'Rua / avenida', visivelSe: noBrasil, enderecoDe: p },
    { tipo: 'texto', chave: `${p}Numero`, rotulo: 'Número', meia: true, visivelSe: noBrasil, enderecoDe: p },
    { tipo: 'texto', chave: `${p}Complemento`, rotulo: 'Complemento', meia: true, opcional: true, placeholder: 'Apto, bloco…', visivelSe: noBrasil, enderecoDe: p },
    { tipo: 'texto', chave: `${p}Bairro`, rotulo: 'Bairro', meia: true, visivelSe: noBrasil, enderecoDe: p },
    { tipo: 'texto', chave: `${p}Cidade`, rotulo: 'Cidade/UF', meia: true, visivelSe: noBrasil, enderecoDe: p },
    { tipo: 'texto', chave: `${p}EndExterior`, rotulo: 'Endereço completo', ajuda: 'Rua, número, complemento', visivelSe: fora, enderecoDe: p },
    { tipo: 'texto', chave: `${p}CidadeExterior`, rotulo: 'Cidade e estado/província', meia: true, visivelSe: fora, enderecoDe: p },
    { tipo: 'texto', chave: `${p}CodPostal`, rotulo: 'Código postal', meia: true, opcional: true, visivelSe: fora, enderecoDe: p },
  );
  return itens;
}

export const expandir = (itens) => itens.flatMap((i) => (i.tipo === 'endereco' ? expandirEndereco(i) : [i]));
export const ehCampo = (i) => !['secao', 'aviso', 'upload', 'endereco'].includes(i.tipo);

export function valoresPadrao(form) {
  const r = {};
  form.etapas.forEach((e) => expandir(e.itens).forEach((i) => { if (ehCampo(i) && i.padrao !== undefined) r[i.chave] = i.padrao; }));
  return r;
}

export const etapasVisiveis = (form, r, d) => form.etapas.filter((e) => avaliar(e.visivelSe, r, d));

const soDigitos = (v) => String(v || '').replace(/\D/g, '');

export function cpfValido(v) {
  const c = soDigitos(v);
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  for (let t = 9; t < 11; t++) {
    let s = 0;
    for (let i = 0; i < t; i++) s += Number(c[i]) * (t + 1 - i);
    if (((s * 10) % 11) % 10 !== Number(c[t])) return false;
  }
  return true;
}

export function erroDeFormato(campo, valor, r, hoje = hojeIso()) {
  const v = String(valor || '').trim();
  switch (campo.validacao) {
    case 'cpf': return cpfValido(v) ? '' : 'CPF inválido — confira os números';
    case 'cep': return soDigitos(v).length === 8 ? '' : 'CEP incompleto';
    case 'email': return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Confira o e-mail';
    case 'dataPassada': return v > hoje ? 'Data no futuro' : '';
    case 'emissaoAposNascimento': {
      if (v > hoje) return 'Data no futuro';
      const nasc = campo.referencia ? String(r[campo.referencia] || '') : '';
      return nasc && v < nasc ? 'A emissão não pode ser antes do nascimento' : '';
    }
    case 'matricula': {
      const n = soDigitos(v).length;
      return n === 32 ? '' : `A matrícula tem 32 números — ${n < 32 ? `faltam ${32 - n}` : 'sobrou número'}`;
    }
    case 'registroAposEvento': {
      if (v > hoje) return 'Data no futuro';
      const evento = campo.referencia ? String(r[campo.referencia] || '') : '';
      return /^\d{4}-\d{2}-\d{2}$/.test(evento) && v < evento ? 'O registro não pode ser antes do nascimento ou do casamento' : '';
    }
    default: return '';
  }
}

export function opcoesDoCampo(campo, d) {
  return campo.opcoesDerivado ? d[campo.opcoesDerivado] || [] : campo.opcoes || [];
}

/** Erro do campo visível: obrigatório vazio ("Preencha este campo") ou formato. */
export function erroDoCampo(campo, r, d) {
  const valor = r[campo.chave];
  const opcional = campo.opcional || campo.tipo === 'check' || (campo.opcionalSe ? avaliar(campo.opcionalSe, r, d) : false);
  if (vazio(valor)) return opcional ? '' : 'Preencha este campo';
  if ((campo.tipo === 'opcoes' || campo.tipo === 'lista') && !opcoesDoCampo(campo, d).includes(String(valor))) return 'Escolha uma das opções';
  return erroDeFormato(campo, valor, r);
}

export function errosDaEtapa(etapa, r, d) {
  const out = {};
  expandir(etapa.itens).forEach((i) => {
    if (!ehCampo(i) || !avaliar(i.visivelSe, r, d)) return;
    const e = erroDoCampo(i, r, d);
    if (e) out[i.chave] = e;
  });
  return out;
}

export const mascaraCpf = (t) => soDigitos(t).slice(0, 11)
  .replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
export const mascaraCep = (t) => { const d = soDigitos(t).slice(0, 8); return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d; };
/** Matrícula da certidão em blocos: 000000 00 00 0000 0 00000 000 0000000 00. */
export const mascaraMatricula = (t) => {
  const d = soDigitos(t).slice(0, 32);
  const out = [];
  let i = 0;
  [6, 2, 2, 4, 1, 5, 3, 7, 2].forEach((n) => { if (i < d.length) { out.push(d.slice(i, i + n)); i += n; } });
  return out.join(' ');
};
export { soDigitos };
